import React, { useEffect, useState } from "react";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";
import Table from "../../components/controls/tables/Table";
import { calculatePageSize } from "../../helpers/utils";

const AllocatedResources = (props) => {
  const {
    portfolioID,
    programID,
    projectID,
    clientID,
    pageLoading,
    getResourcesRequest,
    allAllocatedResources,
    pagination,
  } = props;

  const [data, setData] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [perPageItems] = useState(calculatePageSize());
  const [parentType, setParentType] = useState(null);
  const [tableSearch, setTableSearch] = useState(null);

  useEffect(() => {
    if (allAllocatedResources && allAllocatedResources.length > 0) {
      setData((prevData) => {
        const newMap = new Map(
          allAllocatedResources.map((item) => [item.id, item])
        );

        const updatedPrevData = prevData.map((item) =>
          newMap.has(item.id) ? newMap.get(item.id) : item
        );

        const prevDataIds = new Set(prevData.map((item) => item.id));
        const newItems = allAllocatedResources.filter(
          (shift) => !prevDataIds.has(shift.id)
        );

        return [...updatedPrevData, ...newItems].sort(
          (a, b) => b.isFlagged - a.isFlagged
        );
      });
    } else {
      setData([]);
    }
  }, [allAllocatedResources]);

  // const handleDelete = () => {
  //   const id = JSON.parse(localStorage.getItem("selectedRow")).id;
  //   const updatedArray = allAllocatedResources.filter((item) => item.id !== id);
  //   const idsArray = updatedArray.map((obj) => obj.id);
  //   const payload = {
  //     Name: projectDetails.name,
  //     OwnerId: projectDetails.owner.id,
  //     ClientId: projectDetails.client.id,
  //     assignedUsers: idsArray,
  //   };
  //   deleteProjectResourceRequest({ id: projectID, payload, arr: updatedArray });
  //   localStorage.removeItem("selectedRow");
  // };


  const fetchData = (pageNumber,pageSize, searchTerm, forceClearSearch=false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    payload.parent = parentType;

    if (clientID) {
      payload.id = clientID;
      payload.parent = "Client";
    }

    if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }

    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }

    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }
    getResourcesRequest(payload);
  };

  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems]);

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };

  useEffect(() => {
    if (projectID) {
      setParentType("Project");
    }
    if (programID) {
      setParentType("Program");
    }
    if (clientID) {
      setParentType("Client");
    }
    if (portfolioID) {
      setParentType("Portfolio");
    }
  }, [projectID, programID, clientID, portfolioID]);

  const handleSearchTrigger = (searchTerm) => {
    if ((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if (!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)) {
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
      setPageNum(1);
    }

    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);

  };
  return (
    <ColumnConfigProvider tableName="Allocated Resources">
      <Table
        parentType={parentType}
        type="Allocated Resources"
        rows={data || []}
        searchHandler={handleSearch}
        saveBtnLabel="Save"
        cancelBtnLabel="Cancel"
        setPageNum={setPageNum}
        setIsCreate={setIsCreate}
        loading={pageLoading}
        isCreate={isCreate}
        pagination={pagination}
        clientId={clientID}
        portfolioId={portfolioID}
        programId={programID}
        projectId={projectID}
        setData={setData}
        triggerSearch={handleSearchTrigger}
      />
    </ColumnConfigProvider>
  );
};

export default AllocatedResources;
